var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerphoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33323 3.92133V12.8267C7.33303 13.103 7.23533 13.3704 7.05733 13.5817C6.87933 13.793 6.63245 13.9348 6.36019 13.9819C6.08794 14.0291 5.80777 13.9787 5.56905 13.8395C5.33033 13.7004 5.14837 13.4815 5.05523 13.2213L3.6239 9.12133M3.6239 9.12133C3.05804 8.88074 2.59269 8.45271 2.30658 7.90844C2.02048 7.36418 1.9312 6.73779 2.05385 6.13527C2.17651 5.53274 2.50356 4.9911 2.97966 4.602C3.45577 4.2129 4.05168 4.00023 4.66656 4H5.8879C8.62123 4 10.9712 3.17733 11.9999 2V11.3333C10.9712 10.156 8.6219 9.33333 5.8879 9.33333H4.66656C4.30832 9.33386 3.95366 9.26131 3.6239 9.12133ZM11.9999 8.66667C12.5303 8.66667 13.039 8.45595 13.4141 8.08088C13.7892 7.70581 13.9999 7.1971 13.9999 6.66667C13.9999 6.13623 13.7892 5.62753 13.4141 5.25245C13.039 4.87738 12.5303 4.66667 11.9999 4.66667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphoneOutline);
export default __webpack_public_path__ + "static/media/SpeakerphoneOutline.a857bdedc305485a116e3a7ea9d5f42d.svg";
export { ForwardRef as ReactComponent };